import { ShifterLocalExport } from "."
import { useQuery } from "../../../hooks"


export default function Main() {
    const transferType = useQuery().get('transfer')
    if(transferType === 'export') return <ShifterLocalExport/>
    return <>Unknown transfer</>
}